

import { useState } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                Industryhub
              </h1>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="#home" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Home</a>
                <a href="#brand" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">IH Parts</a>
                <a href="#about" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">About</a>
                <a href="#contact" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Contact</a>
              </div>
            </div>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 hover:text-gray-900 cursor-pointer"
              >
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="#home" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">Home</a>
              <a href="#brand" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">IH Parts</a>
              <a href="#about" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">About</a>
              <a href="#contact" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">Contact</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative bg-white">
        {/* Hero Image */}
        <div className="w-full h-screen bg-cover bg-center bg-no-repeat"
             style={{
               backgroundImage: `url('https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/98b14094e7cd15d0248064ef4a99f720.jpeg')`
             }}>
        </div>
        
        {/* Text Content Below Image */}
        <div className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="text-center text-gray-900 max-w-6xl mx-auto">
              <h1 className="text-5xl md:text-7xl font-bold mb-6">
                THE BRAND BUILT FROM THE FIELD
              </h1>
              <p className="text-xl md:text-2xl mb-8 font-semibold text-teal-600">
                From Factory to Field - OEM-Quality Parts for Angola's Toughest Industries
              </p>
              <p className="text-lg mb-10 max-w-4xl mx-auto text-gray-600">
                Born from the realities of maintenance in Oil & Gas, Mining, Agriculture, Transport, and Infrastructure. 
                We combine real field experience with engineering precision and production control.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Explore IH Parts
                </button>
                <button className="border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Get Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Vision</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Create a brand for maintenance and repair parts that combines real field experience with engineering precision and production control. 
              Quality without compromise, while maintaining the most competitive market pricing through efficient supply chain and local stock management.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-8 text-center">
            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="w-16 h-16 bg-cover bg-center rounded-full mx-auto mb-4" 
                   style={{backgroundImage: `url('https://public.readdy.ai/ai/img_res/e050aac944b6f7753276cfd8cf017f4a.jpg')`}}>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Oil & Gas</h3>
              <p className="text-gray-600 text-sm">Offshore and onshore operations</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="w-16 h-16 bg-cover bg-center rounded-full mx-auto mb-4"
                   style={{backgroundImage: `url('https://readdy.ai/api/search-image?query=Angola%20diamond%20mining%20operations%2C%20Catoca%20diamond%20mine%2C%20Angola%20mining%20industry%2C%20heavy%20mining%20equipment%20in%20Angola%2C%20diamond%20extraction%20facilities%2C%20professional%20mining%20photography&width=64&height=64&seq=angola-mining&orientation=squarish')`}}>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Mining</h3>
              <p className="text-gray-600 text-sm">Heavy equipment maintenance</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="w-16 h-16 bg-cover bg-center rounded-full mx-auto mb-4"
                   style={{backgroundImage: `url('https://readdy.ai/api/search-image?query=Angola%20agriculture%20farming%2C%20coffee%20plantations%20in%20Angola%2C%20agricultural%20machinery%20in%20Angola%20fields%2C%20farming%20equipment%20in%20Angola%20countryside%2C%20Angola%20agricultural%20landscape%2C%20professional%20agricultural%20photography&width=64&height=64&seq=angola-agriculture&orientation=squarish')`}}>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Agriculture</h3>
              <p className="text-gray-600 text-sm">Farm equipment solutions</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="w-16 h-16 bg-cover bg-center rounded-full mx-auto mb-4"
                   style={{backgroundImage: `url('https://readdy.ai/api/search-image?query=Angola%20transport%20infrastructure%2C%20Luanda%20port%20operations%2C%20Angola%20logistics%20trucks%2C%20transportation%20vehicles%20in%20Angola%2C%20Angola%20highway%20transport%2C%20professional%20transport%20photography&width=64&height=64&seq=angola-transport&orientation=squarish')`}}>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Transport</h3>
              <p className="text-gray-600 text-sm">Fleet maintenance parts</p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <div className="w-16 h-16 bg-cover bg-center rounded-full mx-auto mb-4"
                   style={{backgroundImage: `url('https://readdy.ai/api/search-image?query=Angola%20infrastructure%20construction%2C%20Luanda%20city%20development%2C%20Angola%20construction%20projects%2C%20heavy%20construction%20equipment%20in%20Angola%2C%20Angola%20infrastructure%20development%2C%20professional%20construction%20photography&width=64&height=64&seq=angola-infrastructure&orientation=squarish')`}}>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Infrastructure</h3>
              <p className="text-gray-600 text-sm">Construction equipment</p>
            </div>
          </div>
        </div>
      </section>

      {/* IH Parts Brand Section */}
      <section id="brand" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Our Brand — IH Parts</h2>
            <p className="text-lg text-gray-600 mb-8">
              The IH brand reflects our vision to supply reliable, field-proven parts that meet or exceed OEM standards. 
              We design, produce, and stock a comprehensive range of components, fully adapted to Angola's industrial challenges.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Filters */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/c011258f910bd13fd4cc772a8d7984a0.png"
                alt="Filters & Accessories"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Filters & Accessories</h3>
              <p className="text-gray-600 text-sm text-center">
                Premium filtration systems including air, oil, fuel, and hydraulic filters with bases and cups. Engineered using top-grade filtration paper from Hollingsworth & Vose (USA) and Ahlstrom (Finland).
              </p>
            </div>

            {/* GETs */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/3dacceed1eb52353871be333e55e531a.png"
                alt="Ground Engaging Tools"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Ground Engaging Tools</h3>
              <p className="text-gray-600 text-sm text-center">
                Heavy-duty GET components including teeth, adapters, cutting edges, and wear plates. Built to withstand Angola's demanding mining and construction environments with superior durability.
              </p>
            </div>

            {/* Pumps */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/e9dc84b7274b5777bbd3fd21df6530f7.png"
                alt="Pumps"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Pumps</h3>
              <p className="text-gray-600 text-sm text-center">
                Complete pump solutions including water, fuel transfer, electrical fuel, manual fuel, engine oil, and hydraulic oil pumps. Precision-engineered for reliable performance in critical applications.
              </p>
            </div>

            {/* Starters & Alternators */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/286125178e64ffe2d807892336a90129.png"
                alt="Starters & Alternators"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Starters & Alternators</h3>
              <p className="text-gray-600 text-sm text-center">
                High-performance electrical components ensuring reliable engine starting and charging systems. Built for harsh industrial conditions with superior electrical output and longevity.
              </p>
            </div>

            {/* Belts & Tensioners */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/d4ceb77aeed81ae9dc803a5aa5162841.png"
                alt="Belts & Tensioners"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Belts & Tensioners</h3>
              <p className="text-gray-600 text-sm text-center">
                High-strength belts and tensioning systems for engine and auxiliary drives. Engineered for extended service life and reliable power transmission under extreme conditions.
              </p>
            </div>

            {/* Transmission U-Spiders */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/f65fd55e46f218bd95bc8f180e53321a.png"
                alt="Transmission U-Spiders"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Transmission U-Spiders</h3>
              <p className="text-gray-600 text-sm text-center">
                Precision-engineered transmission components including universal joints and spider assemblies. Critical for smooth power transmission in heavy-duty industrial equipment.
              </p>
            </div>

            {/* Turbochargers */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/f121d62574daa262c4cbb92d41c41019.png"
                alt="Turbochargers"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Turbochargers</h3>
              <p className="text-gray-600 text-sm text-center">
                High-efficiency turbochargers and related components for optimal engine performance. Precision-balanced for maximum power output and fuel efficiency in demanding applications.
              </p>
            </div>

            {/* Undercarriage */}
            <div className="bg-white p-6 rounded-xl shadow-lg" data-product-shop>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/57888a83703bfa46cfc323fb2bc6976b.png"
                alt="Undercarriage"
                className="w-full h-32 object-cover object-top rounded-lg mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Undercarriage</h3>
              <p className="text-gray-600 text-sm text-center">
                Complete undercarriage systems including tracks, rollers, sprockets, and idlers. Engineered for maximum traction and durability in Angola's challenging terrain conditions.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
            <p className="text-lg text-gray-600 mb-6">
              Every component is produced under strict OEM specifications, ensuring consistent quality and performance across all product lines.
            </p>
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View Complete Catalog
            </button>
          </div>
        </div>
      </section>

      {/* Trusted Partners */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Trusted by Industry Leaders</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our products are approved and used by major operators in Angola's industrial ecosystem
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 items-center justify-center">
            <div className="text-center bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-900">TIDEWATER</h3>
              <p className="text-gray-600 text-sm mt-2">Offshore Operations</p>
            </div>
            <div className="text-center bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-900">MOTA ENGIL</h3>
              <p className="text-gray-600 text-sm mt-2">Construction & Mining</p>
            </div>
            <div className="text-center bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-900">OMATAPALO</h3>
              <p className="text-gray-600 text-sm mt-2">Industrial Operations</p>
            </div>
            <div className="text-center bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-900">QGMI</h3>
              <p className="text-gray-600 text-sm mt-2">Construction</p>
            </div>
            <div className="text-center bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-bold text-gray-900">& More</h3>
              <p className="text-gray-600 text-sm mt-2">Key Industry Players</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">About Industryhub</h2>
              <p className="text-lg text-gray-600 mb-6">
                Industryhub was born from the realities of maintenance and operation in Angola's toughest sectors. 
                Our mission is to create a brand for maintenance and repair parts that combines real field experience 
                with engineering precision and production control.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                We believe in quality without compromise, while maintaining the most competitive market pricing 
                through efficient supply chain and local stock management.
              </p>
              <p className="text-lg text-gray-600 mb-8">
                Our collaboration between field technicians and factory engineers ensures that every product 
                benefits from on-field feedback and continuous improvement.
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div>
                  <h3 className="text-2xl font-bold text-teal-600 mb-2">Field-Proven</h3>
                  <p className="text-gray-600">Real Experience</p>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-teal-600 mb-2">OEM-Grade</h3>
                  <p className="text-gray-600">Quality Standards</p>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://static.readdy.ai/image/44a66ad7ceec3a79a9eb57293ce567c9/0369f777f15a24e5e4832393cbf3d829.png"
                alt="Industryhub Team"
                className="rounded-xl shadow-lg w-full h-auto object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Contact Industryhub</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Your reliable partner for OEM-quality parts built for the Angolan field. Get in touch for all your industrial parts needs.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-phone-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Phone</p>
                    <p className="text-gray-600">+244 928 192 221</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-mail-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Email</p>
                    <p className="text-gray-600">vendas@industryhubangola.com</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-global-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Website</p>
                    <p className="text-gray-600">www.industryhubangola.com</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-teal-600"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Address</p>
                    <p className="text-gray-600">Viana Km 3 antes do Alimenta Angola</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-8 rounded-xl">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Request Quote</h3>
              <form 
                id="contact-form"
                data-readdy-form
                action="https://readdy.ai/api/form/submit/contact"
                method="POST"
                className="space-y-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.target as HTMLFormElement;
                  const formData = new FormData(form);
                  const data = new URLSearchParams();
                  
                  formData.forEach((value, key) => {
                    data.append(key, value.toString());
                  });

                  fetch('https://readdy.ai/api/form/submit/contact', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: data
                  }).then(() => {
                    alert('Quote request sent successfully!');
                    form.reset();
                  }).catch(() => {
                    alert('Error sending request. Please try again.');
                  });
                }}
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                  <input 
                    type="text" 
                    name="name"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Your Name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                  <input 
                    type="email" 
                    name="email"
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="your@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Company</label>
                  <input 
                    type="text" 
                    name="company"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Your Company"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Industry Sector</label>
                  <select 
                    name="sector"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Select Sector</option>
                    <option value="oil-gas">Oil & Gas</option>
                    <option value="mining">Mining</option>
                    <option value="agriculture">Agriculture</option>
                    <option value="transport">Transport</option>
                    <option value="infrastructure">Infrastructure</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Parts Needed</label>
                  <textarea 
                    rows={4}
                    name="parts_needed"
                    required
                    maxLength={500}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Describe the parts you need (filters, pumps, GET, etc.) and equipment brands..."
                  ></textarea>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-teal-600 hover:bg-teal-700 text-white py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Request Quote
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Industryhub
              </h3>
              <p className="text-gray-400">
                The brand built from the field. OEM-quality parts for Angola's toughest industries - from factory to your facilities.
              </p>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Products</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">Filters</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Pumps</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">GET & Undercarriage</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Electrical Components</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Industries</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">Oil & Gas</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Mining</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Agriculture</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Transport</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Infrastructure</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>+244 928 192 221</li>
                <li>vendas@industryhubangola.com</li>
                <li>Viana Km 3 antes do Alimenta Angola</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Industryhub Angola. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}

